import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SettingModel } from 'src/models/setting.model';
import { LocalStoreManager } from './local-store-manager.service';
import { environment } from 'src/environments/environment';
import { DOCUMENT } from '@angular/common';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' })
};
@Injectable({
  providedIn: 'root'
})
export class RestApiService<T> {

  apiUrl: string;
  setting: SettingModel;
  protected storage: LocalStoreManager;

  constructor(private http: HttpClient, @Inject(DOCUMENT) private document: Document) {
    this.apiUrl = environment.baseUrl || this.getBaseUrl();
  }


  public getBaseUrl(): string {
    const base = this.document.location.origin ||
      this.document.location.protocol + '//' + this.document.location.hostname +
      (this.document.location.port ? ':' + this.document.location.port : '');

    return base.replace(/\/$/, '');
  }

  getToken<T>(data: any): Observable<any> {
    const fullUrl = `${this.apiUrl}Token`;
    const a = JSON.stringify(data);
    return this.http.post<T>(fullUrl, JSON.stringify(data), httpOptions);
  }

  get(): Observable<any> {
    const fullUrl = `${this.apiUrl}`;
    return this.http.get(fullUrl, httpOptions);
  }

  getIpCliente(): Observable<any> {
    return this.http.get('http://api.ipify.org/?format=jsonp&callback=JSONP_CALLBACK').map((res: Response) => res.text());
  }

  testConnection<T>(testUrl: string, CntUrl: string): Observable<any> {
    const fullUrl = `${testUrl}${CntUrl}`;
    return this.http.get<T>(fullUrl, httpOptions);
  }

  getEntity<T>(CntUrl: string): Observable<any> {
    const fullUrl = `${this.apiUrl}/${CntUrl}`;
    return this.http.get<T>(fullUrl, httpOptions);
  }

  getWaiterList<T>(CntUrl: string): Observable<any> {
    const fullUrl = `${this.apiUrl}${CntUrl}`;
    return this.http.get<T>(fullUrl, httpOptions);
  }

  getFilterEntity<T>(CntUrl: string, filter: any): Observable<any> {
    const fullUrl = `${this.apiUrl}/${CntUrl}?Filter=${filter}`;
    return this.http.get<T>(fullUrl, httpOptions);
  }

  getEntityById<T>(CntUrl: string, id: number): Observable<any> {
    const url = `${this.apiUrl}${CntUrl}/${id}`;
    return this.http.get<T>(url, httpOptions);
  }

  postEntity<T>(data, CntUrl: string): Observable<any> {
    const fullUrl = `${this.apiUrl}/${CntUrl}`;
    const jason = JSON.stringify(data);
    return this.http.post<T>(fullUrl, jason, httpOptions);
  }

  updateEntity<T>(id: string, data, CntUrl: string): Observable<any> {
    const url = `${this.apiUrl}${CntUrl}/${id}`;
    return this.http.put<T>(url, data, httpOptions);
  }

  deleteEntity<T>(id: string, CntUrl: string): Observable<{}> {
    const url = `${this.apiUrl}${CntUrl}/${id}`;
    return this.http.delete<T>(url, httpOptions);
  }
}
